import { useLoadImageByIdQuery } from '@/hooks';

interface UseAnnouncementBackgroundImageProps {
  imageId?: number;
  file?: string;
  fileName?: string;
}

interface UseAnnouncementBackgroundImageResult {
  backgroundImage: string | undefined;
  backgroundImageName: string | undefined;
}

export const useAnnouncementBackgroundImage = ({
  imageId,
  file,
  fileName,
}: UseAnnouncementBackgroundImageProps): UseAnnouncementBackgroundImageResult => {
  const { data: fetchedImage } = useLoadImageByIdQuery({ id: imageId! });

  return {
    backgroundImage: file ?? fetchedImage?.data?.file,
    backgroundImageName: fileName ?? fetchedImage?.data?.name,
  };
};
